// extracted by mini-css-extract-plugin
export default {"content":"cXXUUQ_UBfX78heGCkhG"};